// src/hooks/useServices.js
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PublicAPI } from '../api/public';

/**
 * Хук для загрузки списка услуг из API
 * Кеширует результат и обновляет при смене языка
 */
export function useServices() {
  const { i18n } = useTranslation();
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadServices() {
      try {
        setLoading(true);
        setError(null);
        
        const data = await PublicAPI.services({ locale: i18n.language });
        // API возвращает { services: [...], count: N }
        const list = Array.isArray(data?.services) ? data.services : (Array.isArray(data) ? data : []);
        
        if (!cancelled) {
          setServices(list);
        }
      } catch (err) {
        console.error('Failed to load services:', err);
        if (!cancelled) {
          setError(err);
          setServices([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadServices();

    return () => {
      cancelled = true;
    };
  }, [i18n.language]);

  return { services, loading, error };
}
